<script>
  import { t, lang } from "../i18n";
  import CATEGORY_MAP from "../categories";
  import SvgArrow from "./SvgArrow.svelte";

  export let value;
  export let average;
  export let muni;

  const blockWidth = 23;
  const width = CATEGORY_MAP.length * blockWidth;

  $: valueIndex = CATEGORY_MAP.findIndex((cat) => cat.category === value);
  $: averageIndex = CATEGORY_MAP.findIndex((cat) => cat.category === average);
  $: valueX = (valueIndex + 0.5) * blockWidth;
  $: averageX = (averageIndex + 0.5) * blockWidth;
</script>

<svg {width} height="65" viewBox="0 0 {width} 65">
  <SvgArrow x={valueX} y="0" direction="down" fill="black" />
  {#each CATEGORY_MAP as category, index}
    <rect x={index * blockWidth} y="12" width={blockWidth} height="12" fill={category.color} />
  {/each}
  <SvgArrow x={averageX} y="26" direction="up" fill="rgb(0 0 0 / 0.4)" />
  <text x={averageX} y="50" text-anchor="middle">
    <tspan x={averageX}>{t("sidebar-colorbar-average", $lang)}</tspan>
    <tspan x={averageX} dy="1.1em">{muni}</tspan>
  </text>
</svg>

<style>
  svg {
    overflow: visible;
  }
  text {
    font-size: 11px;
    text-align: center;
    fill: rgb(0 0 0 / 0.6);
    font-family: sans-serif;
    text-transform: uppercase;
  }
</style>
